import { QueryKey } from "@tanstack/react-query";

export const getQueryKey = ({ endpoint }: { endpoint: string }): QueryKey => {
  return endpoint.split("/");
};
